export default __webpack_public_path__ + "static/media/HomeIcon.ad923e60.svg";